<template>
  <div class="main">
       <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="modelMenu" current="生命周期研究" :showMore="isMore" />
        <div class="r action-btn-box" v-show="!viewResult">
        <el-button @click="onViewTimeline"  type="primary"  class="actionBtn"  round >查看Timeline <svg-icon name="play" size="12" ></svg-icon> </el-button>
      </div>
      <xy-toolbox-menu class="r" v-show="viewResult">
        <xy-toolbox-menu-item icon="car_search" @click="goback" >返回</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出  </xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
           
    <SearchBar :moduleName="currentModuleName" v-if="!viewResult" :disableResultTab="true">
      <!-- <el-button type="primary" slot="resultButton" @click="onViewTimeline">查看Timeline</el-button>
      <el-button type="danger">进入分析</el-button> -->
    </SearchBar>
    <div v-if="viewResult" style="margin-top:20px;">
 
      <div>
        <div class="block" style="margin:auto;" v-loading = "loading">
          <el-timeline style="text-align:left; ">
            <el-timeline-item v-for="(value,key) in timelineList" :key="key" :label="key" :value="key" :timestamp="key" placement="top">
              <el-collapse   >
                <el-collapse-item name="1">
                  <template slot="title" style="font-size:16px;">新上市{{value.start.length}}款车型,停产{{value.end.length}}款车型</template>
    <el-row>
  <el-col :span="12"><div class="grid-content bg-purple" style="background:#409EFF;  color:#fff;">
         <p v-for="item in value.start" :key="item.id" style="padding:4px 8px;"> {{item.name}} | 工改模:{{item.engineering}} | MSRP:{{item.msrp}}</p>
    </div></el-col>
  <el-col :span="12">
    <div class="grid-content bg-purple-light" style="background:#606266;  color:#fff;" v-if="value.end.length>0">
         <p style="padding:4px 8px;" v-for="item in value.end" :key="item.id"> {{item.name}} | 工改模:{{item.engineering}} | MSRP:{{item.msrp}}</p>
    </div></el-col>
</el-row>
  </el-collapse-item>
      </el-collapse>
 
    </el-timeline-item>
  </el-timeline>
</div>
 </div>

</div>

 
 
</div>
</template>
<script>
  import {
    mapMutations,
    mapGetters,
    mapActions
  } from 'vuex';
  import SearchBar from '@/components/common/NewSearchBar.vue';
  export default {
    name: 'Timeline',
    components: {
      SearchBar
    },
    data() {
      return {
        loading:true,
        isMore:true,
        recentScheme: ['1', '2'],
        viewResult: false,
        showSelectDatetime: false,
        currentModuleName: 'Timeline',
        dataSource: '',
        daterange: null,
      }
    },
    methods: {
      ...mapMutations('commonsearch', ['setPivotTableKey', 'clearSearch']),
      ...mapActions('commonsearch', ['savePivotTableAsync', 'getSaleCategories']),
      ...mapActions('depthanalysis', ['queryTimelineList']),
      onViewTimeline() {
        this.viewResult = true;
        this.isMore = false;
            // alert(this.modelName);
      this.queryTimelineList({
        params: {
          modelName: this.modelName
        },handle: this.hideLoading
      });
      },
      goto() {
      },
      hideLoading(){
        this.loading = false;
      },
      exportExcel() {
        var excelData = [];
        JSONToExcel(excelData, this.modelName, this.modelName);
      },
      goback() {
        this.viewResult =false;

      }
    },
    computed: {
      ...mapGetters('commonsearch', {
        'saleCategories': 'saleCategories',
        'savedSearchSchemas': 'savedSearchSchemas','searchSelectedResult':'searchSelectedResult'
      }),
      ...mapGetters('depthanalysis', {
        'timelineList': 'timelineList'
      }),

      modelName(){
             var list = this.searchSelectedResult;
                 if(list.length>0)
                  {
                    return list[0].model;
                  }
                  return '';

      }
    },
    mounted() {
      this.clearSearch();
     
    },
    watch: {
       
       searchSelectedResult(newValue)
       {
        //alert(JSON.stringify(newValue));
      
       }
    }
  }
</script>
<style>

</style>